import { Routes, Route, Navigate } from 'react-router-dom';
import { ROUTES } from './routeConfig';

/**
 * Renders <Routes> from the route table. Mounted from App.jsx.
 * Add new routes by editing routeConfig.jsx, not this file.
 */
export default function AppRoutes() {
  return (
    <Routes>
      {ROUTES.map((r) => {
        const Page = r.element;
        return <Route key={r.path} path={r.path} element={<Page />} />;
      })}
      <Route path="/case-studies" element={<Navigate to="/case-studies/malta" replace />} />
      <Route path="/certificates" element={<Navigate to="/certificates/ai-101" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
